import { DefaultHigh, DefaultLower, NullBanner } from "@/model/DefaultBanners";
import { RiskLevel } from "@/model/RiskLevel";
import NorthumberlandLogo from "@/assets/regions/northumberland-logo-web.jpg";
const Lower = {};
const Increasing = {
    rawCopy: "For Increasing Risk scores we recommend you cut down on your alcohol drinking, " +
        "click here for more information about your <u>local&nbsp;alcohol&nbsp;service.</u>",
    logoLink: "find-support"
};
const Higher = {
    rawCopy: "For Increasing Risk scores we recommend you cut down on your alcohol drinking, " +
        "click here for more information about your <u>local&nbsp;alcohol&nbsp;service.</u>",
    logoLink: "find-support"
};
export default {
    name: "Northumberland",
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: Increasing,
        [RiskLevel.Higher]: Higher,
        [RiskLevel.High]: DefaultHigh
    },
    logo: {
        file: NorthumberlandLogo,
        width: 283,
        height: 248
    },
    clinics: [
        {
            name: "Northumberland Recovery Partnership",
            description: "Contact ${name}",
            phone: [
                { title: "Referrals", value: "01670 798 280" },
                { title: "Helpline", value: "01670 333 299" },
                { title: "Recovery Academy", value: "01670 798 281" }
            ],
            email: "NTAWNT.nrp@nhs.net.uk",
            website: "https://www.cntw.nhs.uk/services/northumberland-recovery-partnership/",
            isPrimaryProvider: true,
            tagline: "Northumberland Recovery Partnership (NRP) have bases in Blyth, Ashington and Berwick",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1630 }]
                    }
                }
            ],
        },
        {
            name: "Blyth NRP",
            description: "Contact ${name}",
            location: { lat: 55.1274199, lng: -1.5068018 },
            address: "4 Sextant House, Freehold Street, Blyth, NE24 2BA",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1630 }]
                    }
                }
            ],
            phone: ["01670 798 200"],
            email: "NTAWNT.nrp@nhs.net.uk",
            website: "https://www.cntw.nhs.uk/services/northumberland-recovery-partnership/"
        },
        {
            name: "Ashington NRP",
            description: "Contact ${name}",
            location: { lat: 55.1769045, lng: -1.57447 },
            address: "Greenacres, Green Lane, Ashington, NE63 8BL",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1630 }]
                    }
                }
            ],
            phone: ["01670 844 610"],
            email: "NTAWNT.nrp@nhs.net.uk",
            website: "https://www.cntw.nhs.uk/services/northumberland-recovery-partnership/"
        },
        {
            name: "Berwick NRP",
            description: "Contact ${name}",
            location: { lat: 55.772153, lng: -2.0054458 },
            address: "15 Wallace Green, Berwick, TD15 1EB",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1630 }]
                    }
                }
            ],
            phone: ["01289 301 306"],
            email: "NTAWNT.nrp@nhs.net.uk",
            website: "https://www.cntw.nhs.uk/services/northumberland-recovery-partnership/"
        },
    ]
};
//# sourceMappingURL=Northumberland.js.map